import {
  axios_nomination,
} from '@/plugins/axios';
import configuration from '@/configurations';

class LinkedinRepository {

  /**
   * Get Unipile credentials for LinkedIn integration
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async getUnipileCredentials(input) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/linkedin/unipile-credentials`,
      {
        params: input,
      }
    );

    return result.data;
  }

  /**
   * Disconnect Unipile credentials for LinkedIn integration
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async disconnectToLinkedin(input) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/linkedin/disconnect`,
      input
    );

    return result.data;
  }

  /**
   * Create auth url for LinkedIn integration
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async createAuthUrl(input) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/linkedin/auth/url`,
      input
    );

    return result.data;
  }

  /**
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async getUserProfile(input) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/linkedin/get-user-profile`,
      {
        params: input,
      }
    );

    return result.data;
  }

  /**
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async getMessages(input) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/linkedin/messages`,
      input
    );

    return result.data;
  }

  /**
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async getLinkedinContactMappings(input) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/linkedin/contact-mappings`,
      {
        params: input,
      }
    );

    return result.data;
  }

  /**
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async getLinkedinEvents(input) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/linkedin/events`,
      {
        params: input,
      }
    );

    return result.data;
  }

  /**
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async sendInvitation(contact_id, input) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/linkedin/send-invitation/${contact_id}`,
      input
    );

    return result.data;
  }

  /**
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async sendMessage(contact_id, input) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/linkedin/chat/${contact_id}`,
      input
    );

    return result.data;
  }

}

const linkedin_repository = new LinkedinRepository();

export {
  linkedin_repository,
};
